import React from "react";

import { AppLayout } from "layout";

import { PendingVerificationData } from "modules/PendingVerification/components";

type Props = {};

const PendingVerificationContainer = (props: Props) => {

  return (
    <AppLayout>
      <PendingVerificationData />
    </AppLayout>
  );
};

export default PendingVerificationContainer;
